import translations from './translations'

translations.add('en', {
    headerMessage: 'Are you sure you want to cancel?',
    no: 'NO',
    yes: 'YES'
})
